import { bus } from '../bus'

import QuoteModel from './model/Lead'
import QuoteWindow from './windows/LeadWindow'

export default {
	async open(comp, item) {
		var self 	= comp;
		var ent 	= item.id ? await QuoteModel.read(self.axios, item.id) : QuoteModel.entity();

		if (!item.id) {
			ent.employee_id 		= self.$store.state.employee.id;
			ent.department_id 		= self.$store.state.employee.department_id;
			ent._embedded.employee	= self.$store.state.employee;
		}

		self.$store.state.windowStack.push(QuoteWindow, {
			value: ent,
			async submit(entity) {
				if (await QuoteModel.save(self.axios, entity)) {
					self.$store.state.windowStack.pop();
					bus.$emit('update');
				}
			}
		});
	}
};